import api from "../../../../store/AuthHeader";

const getAll = (queryStr: any) => {
    return api
        .get("/publicholiday/getallpublicholidays?" + queryStr);
};

const updatePublicHolidaysFromAPI = () => {
    return api
        .get("/publicholiday/UpdatePublicHolidaysFromAPI");
};

const getById = (id: any) => {
    return api
        .get(`/publicholiday/getpublicholidaybyid?id=${id}`);
    
};

const deleteById = (id: any) => {
    return api
        .delete(`/publicholiday/${id}`);
}; 


export default {
    getAll,
    getById,
    deleteById,
    updatePublicHolidaysFromAPI
};